import React from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

export default function FloatingHeader() {
  const [open, setOpen] = React.useState(false);
  const { pathname } = useLocation();

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="glass fixed top-0 inset-x-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
          <div className="w-8 h-8 border border-primary grid place-items-center primary-glow">
            <span className="font-heading font-black text-primary text-sm leading-none">DW</span>
          </div>
          <div className="leading-tight">
            <div className="font-heading font-bold text-sm tracking-tight">DW Mortgage Hub</div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground font-mono">Mortgage · Lending · Advisory</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-muted-foreground font-mono uppercase tracking-widest text-[11px]">
          <a href="#programs" data-testid="nav-programs" onClick={scrollTo("programs")} className="hover:text-foreground transition-colors">Loan Programs</a>
          <a href="#why-us" data-testid="nav-why" onClick={scrollTo("why-us")} className="hover:text-foreground transition-colors">Why DW</a>
          <a href="#process" data-testid="nav-process" onClick={scrollTo("process")} className="hover:text-foreground transition-colors">Process</a>
          <a href="#stories" data-testid="nav-stories" onClick={scrollTo("stories")} className="hover:text-foreground transition-colors">Stories</a>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="tel:+19015551234" data-testid="header-call" className="text-xs font-mono uppercase tracking-widest text-muted-foreground hover:text-foreground">(901) 555-1234</a>
          <a href="#apply" onClick={scrollTo("apply")} data-testid="header-apply" className="text-sm px-4 py-2 bg-primary text-primary-foreground rounded-sm font-medium primary-glow hover-lift">Apply now</a>
        </div>

        <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="md:hidden text-foreground">
          {open ? <X size={20} /> : <List size={20} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 px-6 py-4 flex flex-col gap-3">
          <a href="#programs" onClick={scrollTo("programs")} className="text-sm text-muted-foreground">Loan Programs</a>
          <a href="#why-us" onClick={scrollTo("why-us")} className="text-sm text-muted-foreground">Why DW</a>
          <a href="#process" onClick={scrollTo("process")} className="text-sm text-muted-foreground">Process</a>
          <a href="#stories" onClick={scrollTo("stories")} className="text-sm text-muted-foreground">Stories</a>
          <a href="#apply" onClick={scrollTo("apply")} data-testid="mobile-apply" className="text-sm px-4 py-2 bg-primary text-primary-foreground rounded-sm text-center font-medium">Apply now</a>
        </div>
      )}
    </header>
  );
}
